import { Controller } from "@hotwired/stimulus"
import { configureListingTrix } from "../listing_trix_config"

const CHIP_CLASS =
  "contract-merge-field inline-flex items-center rounded-full bg-primary/10 px-2 py-0.5 text-xs font-semibold text-primary"

export default class extends Controller {
  static targets = ["editor", "input"]
  static values = {
    mergeFields: { type: Array, default: [] }
  }

  connect() {
    configureListingTrix()
    this.editorTarget.addEventListener("trix-initialize", this.onInitialize)
    this.editorTarget.addEventListener("trix-file-accept", this.blockAttachment)
    this.editorTarget.addEventListener("trix-change", this.syncLiquid)

    this.form = this.element.closest("form")
    if (this.form) this.form.addEventListener("submit", this.onSubmit)
  }

  disconnect() {
    this.editorTarget.removeEventListener("trix-initialize", this.onInitialize)
    this.editorTarget.removeEventListener("trix-file-accept", this.blockAttachment)
    this.editorTarget.removeEventListener("trix-change", this.syncLiquid)
    if (this.form) this.form.removeEventListener("submit", this.onSubmit)
  }

  onInitialize = (event) => {
    if (event.target !== this.editorTarget) return

    const liquid = this.inputTarget.value?.trim()
    if (!liquid) return
    if (!this.editorTarget.editor?.isEmpty?.()) return

    this.editorTarget.editor.loadHTML(this.liquidToEditorHtml(liquid))
  }

  onSubmit = () => {
    this.syncLiquid()
  }

  syncLiquid = () => {
    const html = this.editorTarget.innerHTML
    this.inputTarget.value = this.editorHtmlToLiquid(html)
  }

  insertField(event) {
    event.preventDefault()
    const { key, label } = event.params
    const chip = `<span class="${CHIP_CLASS}" contenteditable="false" data-contract-field="${key}">${label}</span>`
    this.editorTarget.editor.insertHTML(chip)
    this.syncLiquid()
  }

  blockAttachment = (event) => {
    event.preventDefault()
  }

  liquidToEditorHtml(liquid) {
    let html = liquid
    this.mergeFieldsValue.forEach(({ key, label }) => {
      const chip = `<span class="${CHIP_CLASS}" contenteditable="false" data-contract-field="${key}">${label}</span>`
      html = html.split(`{{ ${key} }}`).join(chip)
      html = html.split(`{{${key}}}`).join(chip)
    })
    return html
  }

  editorHtmlToLiquid(html) {
    let liquid = html.replace(
      /<span[^>]*data-contract-field="([^"]+)"[^>]*>.*?<\/span>/gi,
      (_, key) => `{{ ${key} }}`
    )

    this.mergeFieldsValue.forEach(({ key }) => {
      liquid = liquid.split(`{{${key}}}`).join(`{{ ${key} }}`)
    })

    return liquid
  }
}
